export function ConfigureRegistry() {
  return <>Registry panel</>;
}
